<div class="font">
  <div>
    <div class="header">
      <span style="text-align: center">{{ data["subject"] }}</span>
      <mat-icon class="close-icon" (click)="submit(false)">close</mat-icon>
    </div>
  </div>
  <div *ngIf="data['game-name']">
    <div class="message">
      <div>{{'SHARED_PAGE.IF_DELETE' | i18nTranslate}} <span style="font-weight: 600;">{{data["game-name"]}}</span> , {{'SHARED_PAGE.ALL_DATA_DELETE' | i18nTranslate}}</div>
      <br>
      <div>{{'SHARED_PAGE.SURE_TO_DELETE' | i18nTranslate}}</div>
    </div>
  </div>
  <div *ngIf="data['challengeName']">
    <div class="message">
      <div>{{'SHARED_PAGE.SURE_TO_DELETE_CHALLENGE' | i18nTranslate}} {{data["challengeName"]}} ?</div>
    </div>
  </div>
  <div *ngIf="data['customer-name'] && !data['allCustomer']">
    <div class="message" *ngIf="!data['isEmployee']">
      <div>{{'SHARED_PAGE.ARE_YOU_SURE' | i18nTranslate}} <span style="font-weight: 600;">{{data["customer-name"]}}</span> , {{'SHARED_PAGE.FROM_CUSTOM' | i18nTranslate}}</div>    
    </div>
    <div class="message" *ngIf="data['isEmployee']">
      <div>{{'SHARED_PAGE.ARE_YOU_SURE' | i18nTranslate}} <span style="font-weight: 600;">{{data["customer-name"]}}</span> , {{'SHARED_PAGE.FROM_EMPLOYEE' | i18nTranslate}}</div>    
    </div>
  </div>

  <div *ngIf="data['customer-name'] && data['allCustomer']">
    <div class="message" *ngIf="data['allCustomer']">
      <div>{{'SHARED_PAGE.DELETE_CUSTOMER_CONFIRMATION1' | i18nTranslate}} <b>Customer : </b> <span><b>{{data["customer-name"]}}</b> </span> , {{'SHARED_PAGE.FROM_ALLCUSTOMERS' | i18nTranslate}}</div>
      <span>
        This action will also remove <b>all associated data,</b> and <b>cannot be undone.</b> 
      </span>
  </div>
  </div>

  <div *ngIf="data['customer-list-name']">
    <div class="message">
      <div>{{'SHARED_PAGE.ARE_YOU_SURE_DELETE' | i18nTranslate}} <span style="font-weight: 600;">{{data["customer-list-name"]}}</span></div>    
    </div>
  </div>
  <div class="confirm-delete-section" *ngIf="data['allCustomer']">
    <div>
      If you're sure, please type <b>delete</b> below to confirm
    </div>
    <input
      type="text"
      [(ngModel)]="confirmationText"
      placeholder="delete"
      class="confirmation-input"
    />
  </div>
  <div class="button-container">
    <span class="secondary-button-border" (click)="submit(false)"
      data-button-name="Canceled Operation" [attr.data-item-name]="data['data-item']">{{ data["cancelButtonText"]
      }}</span>
    <button class="primary-button" *ngIf="!data['allCustomer']"
      (click)="submit(true)" [attr.data-button-name]="data['data-button']" [attr.data-item-name]="data['data-item']"
      >{{
      data["successButtonText"] }}</button>
      <button class="primary-button" *ngIf="data['allCustomer']"
      (click)="submit(true)" [attr.data-button-name]="data['data-button']" [attr.data-item-name]="data['data-item']"
      [class.disabled]="confirmationText?.toLowerCase() !== 'delete'"
      [disabled]="confirmationText?.toLowerCase() !== 'delete'"
      >{{
      data["successButtonText"] }}</button>
  </div>
</div>